export const ORGANIZATIONS_SET = 'ORGANIZATIONS_SET'
export const ORGANIZATIONS_CREATE = 'ORGANIZATIONS_CREATE'
export const ORGANIZATIONS_UPDATE = 'ORGANIZATIONS_UPDATE'
export const ORGANIZATIONS_DELETE = 'ORGANIZATIONS_DELETE'

export const COMPANIES_SET = 'COMPANIES_SET'
export const COMPANIES_CREATE = 'COMPANIES_CREATE'
export const COMPANIES_UPDATE = 'COMPANIES_UPDATE'
export const COMPANIES_DELETE = 'COMPANIES_DELETE'
